import { render } from "./Messagescenter.vue?vue&type=template&id=b7e35230&scoped=true"
import script from "./Messagescenter.vue?vue&type=script&lang=js"
export * from "./Messagescenter.vue?vue&type=script&lang=js"

import "./Messagescenter.vue?vue&type=style&index=0&id=b7e35230&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e35230"]])

export default __exports__